import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme, props) => ({
  root: {
    color: theme.palette.background.contrastText,
    ...theme.typography.highlight1,
    margin: '4px 0px',
    padding: '5px 0px',
  },
}));

export default useStyles;
